import { render, staticRenderFns } from "./ProductCodes.vue?vue&type=template&id=61a7f38a&scoped=true"
import script from "./ProductCodes.vue?vue&type=script&lang=js"
export * from "./ProductCodes.vue?vue&type=script&lang=js"
import style0 from "./ProductCodes.vue?vue&type=style&index=0&id=61a7f38a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a7f38a",
  null
  
)

export default component.exports